import { render } from "./TreatmentListPage.vue?vue&type=template&id=878581ec&scoped=true"
import script from "./TreatmentListPage.vue?vue&type=script&lang=js"
export * from "./TreatmentListPage.vue?vue&type=script&lang=js"

import "./TreatmentListPage.vue?vue&type=style&index=0&id=878581ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-878581ec"]])

export default __exports__